<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Photo Gallery</p>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <router-link :to="{ name: 'addPhotogallary', params: {} }" class="button is-success is-small btnicon" title="create Activity">
              Create
            </router-link>

            <router-link :to="{ name: 'photogallaryView', params: {} }" class="button is-danger is-small btnicon" title="Photo Gallery">
              Photo Gallery
            </router-link>
          </div>
        </div>
      </div>
      Total Records : <b>{{ total }}</b>
    </section>
    <card-component>
      <form @submit.prevent="Save">
        <div class="columns">
          <div class=" column is-3">
            <label class="label ">User Type <span class="has-text-danger">*</span></label>
            <div class="control">
              <div class="select is-fullwidth">
                <select name="userSelect" required v-model="UserType">
                  <option disabled value>--Select--</option>
                  <option value="ALL">ALL</option>
                  <option value="STUDENT_WISE">STUDENT</option>
                </select>
              </div>
            </div>
          </div>
          <div class="column is-3">
            <label class="label ">From <span class="has-text-danger">*</span></label>
            <div class="control">
              <input class="input" type="date" v-model="fromDate" required />
            </div>
          </div>

          <div class="column is-3">
            <label class="label ">To <span class="has-text-danger">*</span></label>
            <div class="control">
              <input class="input" type="date" :min="this.fromDate" v-model="toDate" required />
            </div>
          </div>
          <div class="column is-3">
            <label class="label ">Filter Action</label>
            <button class="button is-primary m-r-10" type="submit">Apply</button>
          </div>
        </div>
      </form>
    </card-component>
    <section>
      <b-table :paginated="true" :per-page="10" :striped="true" :hoverable="true" v-if="photoGallery.length > 0" :data="photoGallery">
        <template slot-scope="props">
          <b-table-column label="From" field="From" sortable width="50"> {{ props.row.user.firstName || '-' }} {{ props.row.user.lastName || '-' }} </b-table-column>

          <b-table-column label="Title" field="Title" sortable width="50">
            {{ props.row.title || '-' }}
          </b-table-column>

          <b-table-column label="From Date" field="From Date" sortable width="140">
            {{ new Date(props.row.startDate).toLocaleDateString() }}
          </b-table-column>
          <b-table-column label="To Date" field="To Date" sortable width="140">
            {{ new Date(props.row.endDate).toLocaleDateString() }}
          </b-table-column>
          <b-table-column label="Created Date" field="Date" sortable width="50">
            {{ new Date(props.row.createdAt).toLocaleDateString() || '-' }}
          </b-table-column>
          <b-table-column label="Action" custom-key="actions" class="is-actions-cell" width="140" centered>
            <div class="buttons">
              <router-link class="button is-info is-small btnicon" :to="{ name: 'editPhotogallary', params: { photoGalleryID: props.row.id } }" title="Edit Activity">
                <b-icon icon="pencil" size="is-small" />
              </router-link>
              <router-link class="button is-primary is-small btnicon" :to="{ name: 'viewPhotogallary', params: { photoGalleryID: props.row.id } }" title="View Activity">
                <b-icon icon="eye" size="is-small" />
              </router-link>
              <button class="button is-small is-danger" type="button" v-if="props.row.deletedAt='null'" @click.prevent="deletePhotoGallery(props.row.id)" title="Delete">
                  <b-icon icon="trash-can" size="is-small" />
                </button>
            </div>
          </b-table-column>
        </template>
      </b-table>
    </section>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import moment from 'moment'
import Utils from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'photogallaryList',
  components: {
    CardComponent
  },
  data () {
    return {
      loadingComponent: null,
      fromDate: moment().format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      maxToDate: moment().format('YYYY-MM-DD'),
      academicYears: [],
      academicYearID: '',
      stages: [],
      franchiseeArr: [],
      inProgress: false,
      franchiseeID: '',
      UserType: '',
      photoGallery: [],
      total: ''
    }
  },
  async created () {
    await this.getYear()
    await this.onFranchiseeChange()
    await this.getFranchiseeList()
  },
  watch: {
    franchisee: async function () {
      await this.onFranchiseeChange()
    },
    academicYear: async function () {
      await this.onFranchiseeChange()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  methods: {
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        // this.clearAll()
        this.inProgress = false
      }
    },
    getYear: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getFranchiseeList: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee/active`)
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    dateValidation: function (start, end) {
      if (start > end) {
        this.$buefy.dialog.alert({
          type: 'is-danger',
          message: 'End Date must be Less than Start Date !',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
        if (this.filter.fromDate) {
          this.filter.fromDate = moment(`03/31/${this.year}`).format('YYYY-MM-DD')
        }
      }
    },
    async Save () {
      this.loadingComponent = this.$buefy.loading.open()
      try {
        this.photoGallery = []
        this.total = ''
        let getParam = {}
        if (this.franchiseeID.length === 0) {
          this.loadingComponent.close()
          return this.$buefy.toast.open({
            message: 'Please select franchisee',
            type: 'is-danger',
            duration: 4000
          })
        }
        getParam.franchiseeID = this.franchiseeID
        getParam.userType = this.UserType
        getParam.academicYearID = this.academicYearID
        getParam.startDate = this.fromDate
        getParam.endDate = this.toDate
        const { data } = await http.get(`${constants.API_URL}/api/communication/photo-gallery`, {
          params: getParam
        })
        if (data.length === 0) {
          this.$buefy.dialog.alert({
            title: 'No Data',
            message: 'No Data Found',
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        } else {
          this.photoGallery = data
          this.total = this.photoGallery.length
        }

        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Data', errorMessage)
      }
    },
    deletePhotoGallery: async function (photoGalleryId) {
      let ref = this

      this.$buefy.dialog.confirm({
        title: 'Delete PhotoGallery',
        message: 'Do you really want to <b>Delete</b> this record?',
        confirmText: 'Yes',
        cancelText: 'No',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => {
          try {
            ref.loadingComponent = ref.$buefy.loading.open()
            await http.delete(`${constants.API_URL}/api/communication/photo-gallery/${photoGalleryId}`)
            ref.loadingComponent.close()
            this.photoGallery = []
            this.total = this.photoGallery.length
            this.UserType = ''
            this.fromDate = moment().format('YYYY-MM-DD')
            this.toDate = moment().format('YYYY-MM-DD')
            return this.okMsg(`Deleted PhotoGallery Successfully`)
          } catch (e) {
            const errorMessage = (e && e.response && e.response.data.message) || e.message
            ref.loadingComponent.close()
            return this.errMsg(errorMessage)
          }
        }
      })
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
